<template>
  <div style="width: 100%;height: auto;padding-bottom: 100px;padding-top: 60px;" class="flex flex-column align-center">
    <Breadcrumb
        :value="type === '展商' ? [$t('h.tabName1'),$t('h.tabName3') ,$t('h.tabName3Item6')] : [$t('h.tabName1'),$t('h.tabName4') ,$t('h.tabName3Item6')]"/>

    <div style="width: 1200px;" class="flex flex-column align-center">
<!--      <img src="@/assets/img/qianzhengshenqing.jpeg" style="width: 608px;height: 361px;margin: 30px 0;"/>-->
      <img :src="coverImage" style="width: 608px;height: 361px;margin: 30px 0;"/>
      <div
          style="width: 100%;height: 48px;background: #d7000F;border-radius: 1px;margin-top: 24px;padding: 0 45px;font-size: 18px;color: #FFFFFF;font-weight: 500;"
          class="flex align-center">
        {{ $t('h.visaApply.title1') }}
      </div>
      <div
          style="width: 100%;background: #F5F2F0;border-radius: 1px;padding: 24px 45px;font-weight: 500;font-size: 18px;color: #333333;"
          class="flex">
        {{ title }}
<!--        {{ $t('h.visaApply.label1') }}-->
      </div>
      <div
          style="width: 100%;height: 48px;background: #d7000F;border-radius: 1px;margin-top: 24px;padding: 0 45px;font-size: 18px;color: #FFFFFF;font-weight: 500;"
          class="flex align-center">
        {{ $t('h.visaApply.title2') }}
      </div>
      <div style="width: 100%;background: #F5F2F0;border-radius: 1px;padding: 24px 45px;font-weight: 500;font-size: 18px;color: #333333;">
        {{ subTitle }}
<!--        {{ $t('h.visaApply.label2') }}-->
        <div style="margin-top: 12px;">
         <span style="color: #444444;"> {{ $t('h.registerGroup.label12') }}</span>
         <a :href="attachmentUrl" style="color: #d7000F;padding-left: 4px;padding-right: 4px;font-weight: 500;text-decoration: underline;cursor:pointer;" download> {{ $t('h.visaApply.title2') }}</a>
        </div>
        <div style="margin-top: 12px;">
         <span style="color: #444444;">{{ $t('h.visaApply.title4') }}：</span>
         <a href="https://invform.mxydt.com/invitation-form-wire.html" style="color: #d7000F;padding-left: 4px;padding-right: 4px;font-weight: 500;text-decoration: underline;cursor:pointer;" target="_blank">https://invform.mxydt.com/invitation-form-wire.html</a>
        </div>
      </div>
      <div
          style="width: 100%;height: 48px;background: #d7000F;border-radius: 1px;margin-top: 24px;padding: 0 45px;font-size: 18px;color: #FFFFFF;font-weight: 500;"
          class="flex align-center">
        {{ $t('h.visaApply.title3') }}
      </div>
      <div
          style="width: 100%;background: #F5F2F0;border-radius: 1px;padding: 24px 45px;font-weight: 500;font-size: 18px;color: #333333;"
          class="flex">
        {{ remark }}
<!--        {{ $t('h.visaApply.label3') }}-->
      </div>
    </div>
  </div>
</template>

<script>
import { codeConfig } from "../../assets/api";

export default {
  name: "VisaApply",
  data() {
    return {
      type: localStorage.getItem('queryKey'),
      coverImage: null,
      title: null,
      subTitle: null,
      remark: null,
      attachmentUrl: null
    }
  },
  created() {
    this.initConfig()
  },
  methods:{
    initConfig(){
      this.$axios.get(codeConfig + 'VISA_IMAGE').then(res=>{
        this.coverImage = res && res.data.success ? res.data.result : null
      })
      let titleCode = this.$language === 'ZH' ? 'VISA_TITLE':'VISA_TITLE_EN'
      let subTitleCode = this.$language === 'ZH' ? 'VISA_SUBTITLE':'VISA_SUBTITLE_EN'
      let remarkCode = this.$language === 'ZH' ? 'VISA_REMARK':'VISA_REMARK_EN'
      this.$axios.get(codeConfig + titleCode).then(res=>{
        this.title = res && res.data.success ? res.data.result : null
      })
      this.$axios.get(codeConfig + subTitleCode).then(res=>{
        this.subTitle = res && res.data.success ? res.data.result : null
      })
      this.$axios.get(codeConfig + remarkCode).then(res=>{
        this.remark = res && res.data.success ? res.data.result : null
      })
      this.$axios.get(codeConfig + 'VISA_ATTACHMENT').then(res=>{
        this.attachmentUrl = res && res.data.success ? res.data.result : null
      })
    }
  }
}
</script>

<style scoped>

</style>
